import Const from "../constant/Const";
import FetchWithTimeout from "./FetchWithTimeout";

export const checkWhiteList = async () => {
    let result = false;
    await FetchWithTimeout(Const.TURKISH_AIRLINES_URL, {
        method: 'GET',
        mode: 'no-cors',
        headers: {'Access-Control-Allow-Origin': '*'},
        withCredentials: true,
        credentials: 'same-origin',
    }).then(res => {
        if (parseInt(res.status) === 0) result = true;
    }).catch(e => result = false);
    return result;
}

export const checkBackend = async () => {
    let result = false;
    await FetchWithTimeout(process.env.REACT_APP_API_URL + "/api/v1/publicKey", {
        method: 'GET',
        mode: 'cors',
        withCredentials: true,
        credentials: 'same-origin'
    }).then(res => {
        if (res.ok) result = true;
    }).catch(e => result = false);
    return result;
}